import { useBreakpoint } from '@repo/react-hooks';

type CarouselVisibility = {
  showViewAll: boolean;
  showCarouselButtons: boolean;
};

const useCarouselVisibility = (gamesLength: number, type?: string): CarouselVisibility => {
  const { matches: isXL } = useBreakpoint('xl'); // e.g., >= 1200px
  const { matches: isLG } = useBreakpoint('lg'); // e.g., >= 1024px
  const { matches: isMD } = useBreakpoint('md'); // e.g., >= 768px
  const { matches: isSM } = useBreakpoint('sm'); // e.g., >= 640px

  const visibleColumns = isXL ? 6 : isLG ? 4 : isMD ? 4 : isSM ? 3 : 1;

  const allItemsVisible = gamesLength <= visibleColumns;

  const showViewAll = Boolean(type) && !allItemsVisible;
  const showCarouselButtons = !allItemsVisible;

  return { showViewAll, showCarouselButtons };
};

export default useCarouselVisibility;
